import { Disc } from "lucide-react";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function IsRecordingLabel() {
  const isRecording = useVidyoStore((state) => state.isRecording);

  if (!isRecording) {
    return null;
  }

  return (
    <div className="focus-visible:ring-offset-20 inline-flex items-center gap-1 rounded-md border border-border bg-card px-2 py-0.5 focus-visible:outline-none focus-visible:ring focus-visible:ring-ring">
      <div className="relative inline-flex h-3 w-3">
        <Disc className="size-3 text-destructive" />
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
      </div>
      <p className="text-sm font-medium text-secondary">Rec</p>
    </div>
  );
}
